import APP from 'src/main.js'
import AppRecord from './AppRecord.js'

class EntityVehicleCostEstimate extends AppRecord {
  get formatted_fixed_sf(){
    return (this.fixed_sf * 100).round(4)
  }

  set formatted_fixed_sf(value){
    this.fixed_sf = value != 0 ? value /100 : 0
  }

  get formatted_fixed_aep(){
    return (this.fixed_aep * 100).round(4)
  }

  set formatted_fixed_aep(value){
    this.fixed_aep = value != 0 ? value /100 : 0
  }
  
  get issue(){
    return this.constructor.employeeStore.issues.find(isx => isx.id === this.issue_id)
  }
}

export default EntityVehicleCostEstimate
